import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerOverlay,
} from "@chakra-ui/react";
import { DrawerHeader } from "@root/components/userMangement/components";

interface ICustomDrawer {
  open: boolean;
  title: string;
  children: any;
  footer?: any;
  headers?: any;
  onClose: () => void;
}

export const CustomDrawer = ({
  open,
  onClose,
  title,
  children,
  footer,
  headers,
}: ICustomDrawer) => {
  return (
    <Drawer isOpen={open} placement="right" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent
        minW={{ base: "100%", sm: "600px" }}
        bgColor={"theme.bg.box"}
      >
        {headers || (
          <DrawerHeader textColor="white" title={title} onClose={onClose} />
        )}
        <DrawerBody p={"0px"}>{children}</DrawerBody>
        {footer && (
          <DrawerFooter borderTopWidth="1px" borderColor={"gray.600"}>
            {footer}
          </DrawerFooter>
        )}
      </DrawerContent>
    </Drawer>
  );
};
